/**
 * What a directional light tells the scene's shadow fitter. A light declares its Godot shadow
 * parameters on its own `userData` and never sets its shadow camera: the fitter owns that, as
 * Godot's renderer owns directional shadow setup.
 */
import { userDataDeclaration } from '../userDataDeclaration.js';
const declaration = userDataDeclaration('directionalShadow', (candidate) => typeof candidate.maxDistance === 'number' &&
    typeof candidate.pancakeSize === 'number' &&
    typeof candidate.fadeStart === 'number' &&
    typeof candidate.depthBias === 'number' &&
    typeof candidate.normalBias === 'number' &&
    typeof candidate.filterRadius === 'number' &&
    typeof candidate.softShadowAngle === 'number' &&
    typeof candidate.drawsSoftShadow === 'boolean' &&
    typeof candidate.splitCount === 'number' &&
    Array.isArray(candidate.splitOffsets) &&
    typeof candidate.blendSplits === 'boolean' &&
    typeof candidate.sharesAtlas === 'boolean');
/** The `userData` entry that declares a light's shadow, to merge into the light's `userData`. */
export const directionalShadowUserData = declaration.userData;
/** The light's declaration, or null for a light that made none, which the fitter leaves alone. */
export const readDirectionalShadowDeclaration = declaration.read;
//# sourceMappingURL=declaration.js.map